import { getTransformedRequiredFieldsForForm } from 'helpers/forms/menuItem';
import { PRODUCT_VARIANT_FIELD_NAME } from 'constants/menu/menuItemDetailForm';

export function selectItemQuantity(cart, menuItemSlug) {
  return cart.items.reduce(
    (total, { item_slug, quantity }) =>
      item_slug === menuItemSlug ? total + quantity : total,
    0
  );
}

export function selectIsCartEmpty(cart) {
  return cart.quantity === 0;
}

export function selectCartItemById(cartItems, cartItemId) {
  return cartItems.find(i => i.id === parseInt(cartItemId));
}

export function selectMenuItemFormInitialValues(cart, cartItemId) {
  const {
    order_made_for,
    quantity,
    required_fields,
    special_instructions,
    variant
  } = selectCartItemById(cart.items, cartItemId);
  const variantId = variant?.id;

  const initialValues = {
    ...getTransformedRequiredFieldsForForm(required_fields),
    quantity,
    'order-made-for': order_made_for,
    'special-instructions': special_instructions
  };

  if (variantId) {
    initialValues[PRODUCT_VARIANT_FIELD_NAME] = variantId;
  }

  return initialValues;
}
